import {makeStyles} from '@material-ui/core'
import {baseThemeProperties} from '../../../themes'

export const useStyles = makeStyles<typeof baseThemeProperties, {}, 'emptyListsIcon' | 'textCenter'>(theme => ({
  emptyListsIcon: theme.emptyListsIcon,
  textCenter: {
    textAlign: 'center' as const
  },
}))
